import { render, staticRenderFns } from "./notification-support.vue?vue&type=template&id=f27d6b5e&scoped=true&"
import script from "./notification-support.vue?vue&type=script&lang=js&"
export * from "./notification-support.vue?vue&type=script&lang=js&"
import style0 from "./notification-support.vue?vue&type=style&index=0&id=f27d6b5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27d6b5e",
  null
  
)

export default component.exports